import { debounce } from 'lodash-es'
import queueNotifService from '@/services/QueueNotifService'
import IColor from '@/models/IColor'
import colors from '@/data/colors'

export const confirmation = debounce(
  (message: string) => {
    queueNotifService.success(message)
  },
  3000,
  {
    leading: true
  }
)

export const alertMessage = debounce(
  (message: string) => {
    queueNotifService.error(message)
  },
  3000,
  {
    leading: true
  }
)

export const primary: string = '#3f4fa6'
export const main: string = '#2c3e50'

export const slug = (text: string): string => {
  if (!text) {
    return ''
  }
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export const findContrastColor = (value: string | null): string | null => {
  if (!value) {
    return null
  }
  const find: IColor | undefined = colors.find(
    (color: IColor) => color.value === value
  )
  return (find && find.constrastColor) || null
}

export const findDarkValue = (value: string): string | null => {
  if (!value) {
    return null
  }
  const find: IColor | undefined = colors.find(
    (color: IColor) => color.value === value
  )
  return find && find.darkValue ? find.darkValue : null
}

export const findLightValue = (value: string): string | null => {
  if (!value) {
    return null
  }
  const find: IColor | undefined = colors.find(
    (color: IColor) => color.value === value
  )
  return find && find.lightValue ? find.lightValue : null
}

export const findSlightLightValue = (value: string): string | null => {
  if (!value) {
    return null
  }
  const find: IColor | undefined = colors.find(
    (color: IColor) => color.value === value
  )
  return find && find.slightLightValue ? find.slightLightValue : null
}

export const toHex = (text: string): string => {
  return (
    [...text]
      // tslint:disable-next-line: variable-name
      .map((_c: string, i: number) => Number(text.charCodeAt(i)).toString(16))
      .join('')
  )
}
